import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { IPatient, ICondition, ICondition_Stage } from '@ahryman40k/ts-fhir-types/lib/R4';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AbstractAddComponent } from '../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { FormGenModel } from '../../../shared/models/form-gen.model';

@Component({
  selector: 'inc-decourse-add',
  templateUrl: './decourse-add.component.html',
  styleUrls: ['./decourse-add.component.scss'],
})
export class DecourseAddComponent extends AbstractAddComponent<ICondition> implements OnInit, OnDestroy {
  @Input() patient: IPatient;
  @Input() user: any;
  @Input() isModal: boolean;
  @Input() stage: ICondition_Stage[];
  @Input() subjects: FormGenModel[];

  form: FormGroup;
  interval: any;
  actualTime: Date;

  constructor(private modalController: ModalController) {
    super();
  }

  ngOnInit() {
    if (!this.inData) {
      this.refreshTime();
      this.interval = setInterval(() => {
        this.refreshTime();
      }, 1000);
      if (this.user) {
        const obj = {
          reference: this.user.uid,
          display: this.user.displayName
        };
        this.form.get('note.0.authorReference').setValue(obj);
        this.form.get('recorder').setValue(obj);
      }
      if (this.patient) {
        this.form.controls.subject.setValue({
          reference: this.patient.id,
          display: this.patient.name[0].text
        });
      }
      if (this.stage) { this.form.get('stage').setValue(this.stage); }
    } else {
      this.form.patchValue(this.inData);
      this.fillNotes();
    }
    setTimeout(() => { console.log(this.form.value); }, 1500);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      onsetDateTime: new FormControl(''),
      category: new FormArray([
        new FormGroup({
          coding: new FormArray([
            new FormGroup({
              system: new FormControl('http://terminology.hl7.org/CodeSystem/condition-category'),
              code: new FormControl('problem-list-item'),
              display: new FormControl('Problem List Item')
            })
          ]),
          text: new FormControl('')
        }),
      ]),
      note: new FormArray([this.addNote()]),
      subject: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      recorder: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      stage: new FormArray([
        new FormGroup({
          type: new FormGroup({
            text: new FormControl('')
          }),
          summary: new FormGroup({
            text: new FormControl('')
          })
        })
      ])
    });
  }
  onChange(event) { this.form.get('stage.0.summary.text').setValue(event.detail.value); }

  addNote(): FormGroup {
    return new FormGroup({
      authorReference: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      text: new FormControl(''),
      time: new FormControl('')
    });
  }

  fillNotes(): void {
    this.inData.note.map((el, i) => i > 0 ? (this.form.get('note') as FormArray).push(this.addNote()) : null);
    (this.form.get('note') as FormArray).patchValue(this.inData.note);
  }

  refreshTime(): void {
    this.actualTime = new Date();
    this.form.get('onsetDateTime').setValue(this.actualTime.toISOString());
    this.form.get('note.0.time').setValue(this.actualTime.toISOString());
  }

  close(outData?: any) {
    if (this.isModal) {
      outData ? this.modalController.dismiss(outData) : this.modalController.dismiss();
    } else {
      this.save(outData);
    }
  }

}
